<template>
  <div class="Ordersv2">
    <div class="container">
      <!-- Content here -->
      <br />
      <nav class="navbar navbar-light bg-light">
        <span class="navbar-brand mb-0 h1">委託代買幫訂單</span>
      </nav>

      <div>
        <b-tabs content-class="mt-3">
          <b-tab
            title="待評估委託單"
            active
            @click="filterOrdersByStatus(0)"
          ></b-tab>
          <b-tab title="待付款委託單" @click="filterOrdersByStatus(1)"></b-tab>
          <b-tab
            title="待1688出貨委託單"
            @click="filterOrdersByStatus(2)"
          ></b-tab>
          <b-tab
            title="待前往倉庫委託單"
            @click="filterOrdersByStatus(10)"
          ></b-tab>
          <b-tab
            title="待安排國際運輸委託單"
            @click="filterOrdersByStatus(11)"
          ></b-tab>
          <b-tab title="待收貨委託單" @click="filterOrdersByStatus(12)"></b-tab>
          <b-tab title="訂單已完成" @click="filterOrdersByStatus(13)"></b-tab>
          <b-tab
            title="管理客人的訂單"
            @click="filterOrdersByOrderTransferSelected('other')"
          ></b-tab>
        </b-tabs>
      </div>

      <div v-if="displayViews != ''">
        <div
          v-for="(displayView, index) in OrderInfo"
          v-bind:key="(displayView, index)"
        >
          <div role="tablist">
            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle="'accordion' + index" variant="info">
                  <b-avatar size="4em">{{
                    displayView.creat_date_display.split(' ')[0]
                  }}</b-avatar>
                  訂單:{{ displayView.key }}
                </b-button>
              </b-card-header>
              <b-collapse
                v-bind:id="'accordion' + index"
                visible
                accordion="accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="text-left">
                    <div
                      v-for="(order, index) in displayView.orders"
                      v-bind:key="(order, index)"
                    >
                      <div class="card">
                        <div class="card-body">
                          <div>
                            <img
                              class="square"
                              height="100"
                              width="100"
                              v-bind:src="order.image_url_info[0]"
                              referrerpolicy="no-referrer"
                            />
                            <b class="pl-2">{{ order.prod_name }}</b>
                          </div>
                          <a
                            v-bind:href="order.origin_url"
                            target="_blank"
                            title="阿里巴巴工廠連結"
                            >阿里巴巴工廠連結</a
                          >
                          <b-button
                            variant="outline-primary"
                            style="float: right"
                            @click="addTheProd(order.parse_prod_url)"
                            >加購此商品</b-button
                          >
                          <hr size="10" />
                          <div v-if="order.color_name_selected">
                            <p>選擇的顏色: {{ order.color_name_selected }}</p>
                          </div>
                          <div v-if="!order.color_name_selected">
                            <p>選擇的顏色: 無</p>
                          </div>
                          <div v-if="order.color_image_selected">
                            <img
                              height="100"
                              width="100"
                              v-bind:src="order.color_image_selected"
                              referrerpolicy="no-referrer"
                            />
                          </div>
                          <hr size="10" />
                          <div
                            v-for="(sku_info, skuInfoIndex) in order.sku_info"
                            v-bind:key="(sku_info, skuInfoIndex)"
                          >
                            <div v-if="sku_info.amount != 0">
                              <p>款式: {{ sku_info.sku_name }}</p>
                              <p>數量: x{{ sku_info.amount }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <hr size="10" />

                    <p>
                      <b-avatar variant="info"></b-avatar>
                      收貨姓名:{{ displayView.user_order_name }}
                    </p>
                    <p>收貨電話:{{ displayView.user_phone }}</p>
                    <p>收貨Email:{{ displayView.user_email }}</p>

                    <div v-if="displayView.order_transfer_selected == 'other'">
                      <b-input-group class="mb-3" prepend="客人身分證">
                        <b-form-input
                          v-model="displayView.user_identity"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            pill
                            variant="outline-info"
                            @click="updateIdentity(displayView.user_identity)"
                            >更新</b-button
                          >
                        </b-input-group-append>
                      </b-input-group>
                    </div>

                    <div v-if="displayView.product_delivery == 'delivery'">
                      <p>收貨地址:{{ displayView.user_address }}</p>
                    </div>

                    <div v-if="displayView.product_delivery == 'deliveryStore'">
                      <div
                        v-if="
                          displayView.map_info.logistics_sub_type == 'FAMIC2C'
                        "
                      >
                        <p>取貨超商:全家店到店</p>
                      </div>
                      <div
                        v-if="
                          displayView.map_info.logistics_sub_type ==
                          'UNIMARTC2C'
                        "
                      >
                        <p>取貨超商:7-ELEVEN 超商交貨便</p>
                      </div>
                      <div
                        v-if="
                          displayView.map_info.logistics_sub_type == 'HILIFEC2C'
                        "
                      >
                        <p>取貨超商:萊爾富店到店</p>
                      </div>
                      <p>取貨超商地址:{{ displayView.map_info.cvs_address }}</p>
                      <p>取貨超商:{{ displayView.map_info.cvs_store_name }}</p>
                      <p>
                        取貨超商編號:{{ displayView.map_info.cvs_store_id }}
                      </p>
                    </div>

                    <p>
                      下單日期:
                      {{ displayView.creat_date_display.split(' ')[0] }}
                    </p>

                    <div v-if="displayView.total == 0">
                      <p>
                        <b>付款金額: 等待工廠確認</b>
                      </p>
                    </div>
                    <div v-if="displayView.total != 0">
                      <p>
                        <b>總付款金額: ${{ displayView.total }} 台幣</b>
                      </p>
                    </div>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>
      </div>

      <div v-if="displayViews != ''">
        <!-- footer -->
        <div class="jumbotron jumbotron-fluid">
          <div class="container">
            <h1 class="display-4"></h1>
            <p class="lead">此狀態有:{{ orderCount }}訂單</p>
          </div>
        </div>
        <!-- footer -->
      </div>
      <div v-if="displayViews == ''">
        <!-- footer -->
        <div class="jumbotron jumbotron-fluid">
          <div class="container">
            <h1 class="display-4"></h1>
            <p class="lead">目前沒有任何訂單</p>
          </div>
        </div>
        <!-- footer -->
      </div>
    </div>
    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="false"
    ></loading>
    <v-dialog />
  </div>
</template>
<style type="text/css">
.square {
  width: 100px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 1);
}

.P-logo {
  height: 100px;
  width: 100px;
}

.countdown {
  padding: 0px 10px;
}

.expiry_date {
  font-weight: bold;
}

.send_date {
  font-weight: bold;
}

.count_l1 {
  font-weight: bold;
}

.count_l2 {
  font-weight: bold;
}

.prod_detail {
  font-size: 10px;
}

.category_text {
  text-align: left;
  padding: 10px 0px;
}

.category_scrollview {
  overflow: hidden;
  width: auto;
  overflow-x: auto;
  white-space: nowrap;
}

.category_button {
  display: inline-block;
  padding: 0px 2px;
}

.card_button {
  padding: 10px 0px;
}

.card_contain {
  padding: 20px;
  width: 18rem;
}

.checkbox_size {
  zoom: 2;
  width: 20px;
  height: 20px;
}
</style>
<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import axios from 'axios'
import CryptoJS from 'crypto-js'
export default {
  name: 'orders',
  components: {
    loading: VueLoading,
  },
  data: function () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      isLoading: true,
      userId: '',
      userImage: '',
      userName: '',
      categoryViews: '',
      displayViews: '',
      nowStatus: 0,
      checkUnChatbotSigninStatus: false,
      filterStatus: 0,
      OrderInfo: [],
      orderCount: 0,
    }
  },
  watch: {},
  computed: {},
  methods: {
    filterOrdersByStatus: function (status) {
      const vm = this
      vm.filterStatus = status
      vm.filterOrdersViewsByStatus()
    },
    filterOrdersViewsByStatus: function () {
      const vm = this
      vm.isLoading = true
      vm.OrderInfo = []

      for (let orderObjects of vm.displayViews) {
        // console.log(orderObjects);
        if (orderObjects.status == vm.filterStatus) {
          vm.OrderInfo.push(orderObjects)
          vm.orderCount = vm.OrderInfo.length
        }
        if (orderObjects.hasOwnProperty('user_identity')) {
          orderObjects.user_identity = vm.decryptECB(orderObjects.user_identity)
        }
      }
      if (vm.OrderInfo == '') {
        vm.$toast.open({
          message: '目前沒有訂單!',
          type: 'error',
        })
      } else {
        vm.$toast.open({
          message: '查詢成功!',
          type: 'success',
        })
      }
      vm.isLoading = false
      this.$forceUpdate()
    },
    filterOrdersByOrderTransferSelected: function (orderTransferSelected) {
      const vm = this
      vm.isLoading = true
      vm.OrderInfo = []

      for (let orderObjects of vm.displayViews) {
        // console.log(orderObjects);
        if (orderObjects.order_transfer_selected == orderTransferSelected) {
          vm.OrderInfo.push(orderObjects)
          vm.orderCount = vm.OrderInfo.length
        }
        if (orderObjects.hasOwnProperty('user_identity')) {
          orderObjects.user_identity = vm.decryptECB(orderObjects.user_identity)
        }
      }
      if (vm.OrderInfo == '') {
        vm.orderCount = 0
        vm.$toast.open({
          message: '目前沒有訂單!',
          type: 'error',
        })
      } else {
        vm.$toast.open({
          message: '查詢成功!',
          type: 'success',
        })
      }
      vm.isLoading = false
      this.$forceUpdate()
    },
    checkUnChatbotSignin: function () {
      const vm = this
      if (!localStorage.userId) {
        this.$modal.show('dialog', {
          title: '🙋您尚未登入FB會員',
          text: '請先登入才能使用此服務喔⚡',
          buttons: [
            {
              title: '關閉',
            },
            {
              title: '👉用FB登入',
              handler: () => {
                window.location = 'https://m.me/2266831083395361'
              },
            },
          ],
        })

        vm.checkUnChatbotSigninStatus = true
        return true
      } else {
        vm.userName = localStorage.userName
        vm.checkUnChatbotSigninStatus = false
        return false
      }
    },
    queryOrderByUserId: function (userId) {
      const vm = this
      vm.isLoading = true
      vm.$toast.open({
        message: '查詢中!',
        type: 'success',
      })
      axios
        .post(vm.apiUrl + 'QueryNewOrderByUserId', {
          userId: userId,
        })
        .then(function (response) {
          if (response.data.length == 0) {
            // alert("系統錯誤請稍後再試");
            vm.$toast.open({
              message: '目前沒有訂單!',
              type: 'error',
            })
          } else {
            vm.displayViews = response.data
            vm.filterOrdersViewsByStatus()
            // vm.$toast.open({
            //   message: "查詢成功!",
            //   type: "success"
            // });
          }
          vm.isLoading = false
          document.body.scrollTop = 0
          document.documentElement.scrollTop = 0
          // console.log(response.data);
        })
        .catch(function (error) {
          alert(error)
          // console.log(error);
        })
    },
    addTheProd: function (parseProdUrl) {
      const vm = this
      vm.$store.addBuyUrl = parseProdUrl
      vm.$router.push('alibabaorderv2?userId=' + vm.$route.query.userId)
    },
    updateIdentity: function () {
      // const vm = this;
    },
    decryptECB(word, keyStr) {
      keyStr = keyStr || '9XSvkQ2CAZNeqUv6v8apPEqhEdS4dYGk'
      var key = CryptoJS.enc.Utf8.parse(keyStr)
      var decrypt = CryptoJS.AES.decrypt(word, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      })
      return CryptoJS.enc.Utf8.stringify(decrypt).toString()
    },
  },
  mounted() {
    const vm = this
    vm.isLoading = false

    try {
      if (vm.$route.query.userId) {
        localStorage.userId = decodeURI(vm.$route.query.userId)
      }
      vm.checkUnChatbotSignin()
      vm.queryOrderByUserId(localStorage.userId)
    } catch (e) {
      // console.info(e);
      alert(e)
    }
  },
}
</script>
